import React, { useState } from "react";
import { Formik, FormikProps } from "formik";
import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { Snackbar } from "../../../../../components/ui";
import * as constants from "../constants";
import { INewRithmicAccountData } from "../../../../../api/rithmic/index.types";
import { INewRithmicAccountFormData } from "../index";
import { RITHMIC_API_URLS, RithmicAPI } from "../../../../../api/rithmic";

interface Props {
  children: (
    formikProps: FormikProps<INewRithmicAccountData>,
    mutation: UseMutationResult<void, unknown, INewRithmicAccountFormData>
  ) => React.ReactNode;
}

const CreateAccountFormContainer: React.FC<Props> = ({ children }) => {
  const [isOpenSnackbar, setIsOpenSnackbar] = useState<boolean>(false);

  const mutation = useMutation({
    mutationKey: [RITHMIC_API_URLS.create_rithmic_account],
    mutationFn: async (data: INewRithmicAccountFormData) => {
      //@ts-ignore
      const assets = data.formValues.assets.map((a) => a.value);
      data.formValues.assets = assets;
      if (data.formValues.country === "United States") {
        data.formValues.country = "USA";
      }
      const result = await RithmicAPI.createRithmicAccount(data.formValues);
      setIsOpenSnackbar(true);
      data.form.resetForm();
      return result;
    },
    onError: () => {
      setIsOpenSnackbar(true);
    },
  });

  const isSuccess = mutation.isSuccess;
  const isError = mutation.isError;

  return (
    <>
      <Snackbar
        type={isSuccess ? "success" : isError ? "error" : ""}
        isOpenSnackbar={isOpenSnackbar}
        responseSuccessMessage="Rithmic account created successfully"
        responseErrorMessage={
          //@ts-ignore
          mutation?.error?.response?.data?.message ||
          "There was an error creating the Rithmic account"
        }
        onClose={() => setIsOpenSnackbar(false)}
      />

      <Formik
        enableReinitialize
        validateOnMount
        initialValues={constants.INITIAL_VALUES}
        validationSchema={constants.VALIDATION_SCHEMA}
        onSubmit={(formValues, form) => {
          mutation.mutate({ formValues, form });
        }}
      >
        {(formikProps) => {
          return children(formikProps, mutation);
        }}
      </Formik>
    </>
  );
};

export default CreateAccountFormContainer;
